"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorkLogErrors = exports.getProjectWorkLogsDictionary = exports.ruleToErrorString = exports.validateComplexCase = exports.getProjectWorkLogsList = exports.parseHash = exports.hashRule = exports.getWorkLogRule = exports.isWorkLogReadyToSave = exports.ValidationType = exports.LogType = void 0;
var _ = require("lodash");
var formatter_1 = require("../helpers/formatter");
var LogType;
(function (LogType) {
    LogType["TRAVELLING"] = "travelling";
    LogType["WORKING"] = "working";
    LogType["SPECIAL"] = "special";
    LogType["OTHER"] = "other";
})(LogType = exports.LogType || (exports.LogType = {}));
var ValidationType;
(function (ValidationType) {
    ValidationType["PROJECT"] = "1010";
    ValidationType["TRAVELLING"] = "1210";
    ValidationType["NOT_WORKED"] = "special";
})(ValidationType = exports.ValidationType || (exports.ValidationType = {}));
// For error translations
var TIME_TYPE_LANG = (_a = {},
    _a[ValidationType.PROJECT.toString()] = 'Werkuren',
    _a[ValidationType.TRAVELLING.toString()] = 'Reisuren',
    _a[ValidationType.NOT_WORKED.toString()] = 'Niet Gewerkt',
    _a);
var isWorkLogReadyToSave = function (worklog) {
    return (!!worklog.projectType || !!worklog.specialType)
        && (worklog.hours > 0 || worklog.approvedHours > 0);
};
exports.isWorkLogReadyToSave = isWorkLogReadyToSave;
var getWorkLogRule = function (worklog) {
    var rule = { timeType: null, locationId: null };
    // Cases for working hours
    if (worklog.type === LogType.WORKING || worklog.type === LogType.TRAVELLING) {
        rule.locationId = (worklog.project && worklog.project._id) || null;
        var projectTypeCode = worklog.projectType ? worklog.projectType.code.toString() : '';
        switch (projectTypeCode) {
            // Logs with special rules
            case ValidationType.TRAVELLING:
                rule.timeType = ValidationType.TRAVELLING;
                break;
            default:
                rule.timeType = ValidationType.PROJECT; // Computed as total project
        }
        return rule;
    }
    // In case of special, for example, id can be log id.
    if (worklog.type === LogType.SPECIAL) {
        rule.timeType = ValidationType.NOT_WORKED;
        return rule;
    }
    // This worklog has no rule attached to compare
    return null;
};
exports.getWorkLogRule = getWorkLogRule;
var hashRule = function (rule) {
    if (!rule) {
        return '';
    }
    var id = rule.locationId instanceof Array ? rule.locationId.join(',') : rule.locationId;
    return id + '&' + rule.timeType;
};
exports.hashRule = hashRule;
var parseHash = function (hash) {
    var hashArray = hash.split('&');
    var locationIds = hashArray[0].split(',');
    // If is single , is not a array of 1 but just string
    return {
        locationId: (locationIds.length === 1) ? locationIds[0] : locationIds,
        timeType: hashArray[1],
    };
};
exports.parseHash = parseHash;
var getProjectWorkLogsList = function (worklogs) {
    var projects = _.chain(worklogs)
        .filter(function (log) { return !!log.project && !!log.project._id; })
        .map(function (log) { return log.project; })
        .uniqBy('_id')
        .value();
    return projects;
};
exports.getProjectWorkLogsList = getProjectWorkLogsList;
/** ------------------------- WORKLOG VALIDATION ------------------------ */
var validateComplexCase = function (rule, maxTime, worklogs) {
    // In case of simple case, will make array, avoid crashing
    if (!(rule.locationId instanceof Array)) {
        var locationId = rule.locationId;
        rule.locationId = [];
        rule.locationId.push(locationId);
    }
    // Find all the logs that overlap and match the required type
    var worklogsInRule = _.filter(worklogs, function (worklog) {
        // 1st, we check the logs that overlap the prpject
        // LocationId is in deed a list of projectIds
        if (!rule.locationId.find(function (projectId) { return projectId === worklog.project._id; })) {
            return false;
        }
        // 2nd calculate the type
        var worklogRule = (0, exports.getWorkLogRule)(worklog);
        if (!worklogRule) {
            return false;
        }
        // If location and type matches, then is filtered
        return worklogRule.timeType === rule.timeType;
    });
    // Finally we get the total time o the worklogs in the time,
    var totalTime = _.sumBy(worklogsInRule, 'hours');
    // Returns true if the total time does not exceed the maximumt time
    return totalTime <= maxTime;
};
exports.validateComplexCase = validateComplexCase;
var ruleToErrorString = function (rule, maxTime, projects) {
    // Get the names of the projects related in this rule
    var projectNames = rule.locationId.map(function (projectId) { return projects[projectId].name; }).join(', ');
    // Translate the code type to a dutch redible string
    // timeType is never null in this stage
    var typeString = rule.timeType && TIME_TYPE_LANG[rule.timeType.toString()]; // Return
    return "De totale ".concat(typeString, " van de projecten ").concat(projectNames, "\n     mag niet meer dan ").concat(formatter_1.Hour.durationToHourMinuteString(maxTime), " duren");
};
exports.ruleToErrorString = ruleToErrorString;
var getProjectWorkLogsDictionary = function (worklogs) {
    return _.keyBy((0, exports.getProjectWorkLogsList)(worklogs), '_id');
};
exports.getProjectWorkLogsDictionary = getProjectWorkLogsDictionary;
/**
 *
 * @return errorList is the human redible erros. Error types, if the error belongs to which type of time
 */
var getWorkLogErrors = function (worklogs, validations) {
    if (validations.length === 0) {
        return { errorList: [], errorTypes: [] };
    }
    // Get the projects, we need them to display the name error
    var projects = (0, exports.getProjectWorkLogsDictionary)(worklogs);
    // Reduce become our list in a list of helpfull errors
    var reduceCallback = function (_a, validationRule) {
        var errorList = _a.errorList, errorTypes = _a.errorTypes;
        var rule = (0, exports.parseHash)(validationRule.key);
        // if the rule is valid, then we push the error. Only take in account complex rules
        if (rule.timeType
            && (rule.locationId instanceof Array)
            && !(0, exports.validateComplexCase)(rule, validationRule.hours, worklogs)) {
            errorList.push((0, exports.ruleToErrorString)(rule, validationRule.hours, projects));
            errorTypes.push(rule.timeType);
        }
        return { errorList: errorList, errorTypes: errorTypes };
    };
    var _a = _.reduce(validations, reduceCallback, { errorList: [], errorTypes: [] }), errorList = _a.errorList, errorTypes = _a.errorTypes;
    return { errorList: _.uniq(errorList), errorTypes: _.uniq(errorTypes) }; // remove duplicated errors
};
exports.getWorkLogErrors = getWorkLogErrors;
